import { Component, OnInit, Input, HostListener, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs';

import { InvoiceService } from '../../../../services/accounting/invoice.service';
import { NotyService } from '../../../../services/common/noty.service';
import { HttpClientService } from '../../../../services/common/http-client.service';
import { AuthService } from '../../../../services/common/auth.service';

@Component({
  selector: 'app-invoice-index',
  templateUrl: './invoice-index.component.html',
  styleUrls: ['./invoice-index.component.scss']
})
export class InvoiceIndexComponent implements OnInit {

  @Input() matter_id: number;

  fetchInvoicesParams: any = {
    page: 1,
    per_page: 30,
    get_invoices: true
  };

  createInvoicesParams: any = {};

  invoices: Array<any> = [];

  count: number;

  isFetching: boolean = false;

  searching: boolean = false;

  formOptions: any = {
  };

  sidebarMaximized: boolean = true;

  sidebarOpen: boolean = false;

  /**
   * Subscription to router events to catch page changes and matter id changes in the URL
   * @type {Subscription}
  */
  routerEventsSubscription: Subscription;

   constructor(
    private httpClientService: HttpClientService,
    private invoiceService: InvoiceService,
    private notyService: NotyService,
    private route: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    ){
  }

  ngOnInit(): void {
    this.initialize();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.matter_id && changes.matter_id.currentValue)
      this.invoiceService.getFormOptions().then((response_json) => {
        this.formOptions = response_json;
        this.fetchInvoicesParams.per_page = response_json.per_page;
        this.fetchInvoices();
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 500);
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 5000);
  }

  @HostListener('window:scroll', ['$event'])
   window_scroll(event: Event) {
    this.content_sidebar_scroll();
  }

  @HostListener('window:resize', ['$event'])
   window_resize(event: Event) {
    this.content_sidebar_scroll();
  }

  initialize() {
    this.invoiceService.getFormOptions().then(response_json =>{
      console.log("getFormOptions", response_json);
      this.formOptions = response_json;
      if(this.formOptions && this.formOptions.per_page)
        this.fetchInvoicesParams.per_page = this.formOptions.per_page;
      this.fetchInvoices()
    }).catch(getFormOptionsError=>{
      console.log("getFormOptions inside initialize", getFormOptionsError);
    });
  }

  clearCreateForm() {
    this.fetchInvoicesParams = {
      page: 1,
      per_page: 50,
      get_invoices: true
    }
  }

  createInvoices() {
    console.log("create params", this.createInvoicesParams)
    let newPageUrl: string = this.httpClientService.buildNewPageUrl("invoices/new", this.createInvoicesParams);
    console.log("window.location.href", window.location.href);
    console.log("newPageUrl", newPageUrl);
    if(window.location.href != newPageUrl)
      this.httpClientService.setNewPageUrl(newPageUrl);
      window.location.reload();
  }

  fetchInvoices(pageEvent: any = null, isFetching: boolean | null = false) {
    if (isFetching)
      this.isFetching = true;
    if (pageEvent) this.fetchInvoicesParams.page = pageEvent.page;
    this.fetchInvoicesParams.matter_id = this.matter_id;
    this.invoiceService.getInvoices(this.fetchInvoicesParams).then(response_json => {
      console.log("index", response_json);
      ({invoices: this.invoices, count: this.count} = response_json)
      if (isFetching)
        this.isFetching = false
    }).catch(() =>{
      this.notyService.notify('Error loading invoices', 'error')
    })
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  markPaid(invoice: any) {
    if (invoice.is_paid || invoice.actionInProgress) return;

    if (!confirm(`Are you sure you want to mark Invoice #${invoice.id} as paid?`)) return;

    invoice.actionInProgress = true;
    this.invoiceService.markInvoicePaid(invoice.id).then(response => {
      invoice.actionInProgress = false;
      if (response.success) {
        invoice.is_paid = true;
        invoice.paid_at = new Date().toISOString();
        this.notyService.notify(response.message, 'success');
      } else {
        this.notyService.notify(response.message || 'Failed to mark invoice as paid', 'error');
      }
    }).catch(error => {
      invoice.actionInProgress = false;
      this.notyService.notify('Error marking invoice as paid', 'error');
      console.error('Error marking invoice as paid:', error);
    });
  }

  withdrawInvoice(invoice: any) {
    if (invoice.actionInProgress) return;

    if (!confirm(`Are you sure you want to withdraw Invoice #${invoice.id}? This will reverse all associated bills back to unbilled status.`)) return;

    invoice.actionInProgress = true;
    this.invoiceService.withdrawInvoice(invoice.id).then(response => {
      invoice.actionInProgress = false;
      if (response.success) {
        invoice.is_deleted = true;
        this.notyService.notify(response.message, 'success');
      } else {
        this.notyService.notify(response.message || 'Failed to withdraw invoice', 'error');
      }
    }).catch(error => {
      invoice.actionInProgress = false;
      this.notyService.notify('Error withdrawing invoice', 'error');
      console.error('Error withdrawing invoice:', error);
    });
  }

}